/**
 * Application route paths (single source of truth for router and navigation).
 */
export const routes = {
  home: "/",
  importKeys: "/import-keys",
  dashboard: "/dashboard",
  upload: "/upload",
  image: (id: string) => `/images/${id}`,
  keys: "/keys",
  quarantine: "/quarantine",
  trash: "/trash",
  account: "/account",
  help: "/help",
  setupDiagnostics: "/setup/diagnostics",
  setupKeys: "/setup/keys",
} as const;
